import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter, MapPin, Phone, Mail, Heart, MessageCircle, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-rose-50 pt-16 pb-8" data-id="element-458">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-459">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-460">
          {/* Brand */}
          <div className="space-y-4" data-id="element-461">
            <h3 className="font-serif text-2xl font-bold text-rose-500" data-id="element-462">
              Bloom & Pop
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-463">
              Creating moments of joy with personalized balloons, bespoke gift
              boxes, and fresh floral arrangements.
            </p>
            <div className="flex space-x-4" data-id="element-464">
              <a href="#" className="text-rose-400 hover:text-rose-600 transition-colors" aria-label="Instagram" data-id="element-465">
                <Instagram className="w-5 h-5" data-id="element-466" />
              </a>
              <a href="#" className="text-rose-400 hover:text-rose-600 transition-colors" aria-label="Facebook" data-id="element-467">
                <Facebook className="w-5 h-5" data-id="element-468" />
              </a>
              <a href="#" className="text-rose-400 hover:text-rose-600 transition-colors" aria-label="Twitter" data-id="element-469">
                <Twitter className="w-5 h-5" data-id="element-470" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-471">
            <h4 className="font-semibold text-gray-900 mb-4" data-id="element-472">Shop</h4>
            <ul className="space-y-2" data-id="element-473">
              <li data-id="element-474">
                <Link to="/shop" className="text-gray-600 hover:text-rose-500 transition-colors" data-id="element-475">
                  All Products
                </Link>
              </li>
              <li data-id="element-476">
                <Link to="/balloons" className="text-gray-600 hover:text-rose-500 transition-colors" data-id="element-477">
                  Balloons
                </Link>
              </li>
              <li data-id="element-478">
                <Link to="/flowers" className="text-gray-600 hover:text-rose-500 transition-colors" data-id="element-479">
                  Flowers
                </Link>
              </li>
              <li data-id="element-480">
                <Link to="/gift-boxes" className="text-gray-600 hover:text-rose-500 transition-colors" data-id="element-481">
                  Gift Boxes
                </Link>
              </li>
              <li data-id="element-482">
                <Link to="/occasions" className="text-gray-600 hover:text-rose-500 transition-colors" data-id="element-483">
                  Custom Orders
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div data-id="element-484">
            <h4 className="font-semibold text-gray-900 mb-4" data-id="element-485">Help</h4>
            <ul className="space-y-2" data-id="element-486">
              <li data-id="element-487">
                <Link to="/about" className="text-gray-600 hover:text-rose-500 transition-colors" data-id="element-488">
                  About Us
                </Link>
              </li>
              <li data-id="element-489">
                <Link to="/contact" className="text-gray-600 hover:text-rose-500 transition-colors" data-id="element-490">
                  Contact Us
                </Link>
              </li>
              <li data-id="element-491">
                <Link to="/delivery-info" className="text-gray-600 hover:text-rose-500 transition-colors" data-id="element-492">
                  Delivery Info
                </Link>
              </li>
              <li data-id="element-493">
                <Link to="/faq" className="text-gray-600 hover:text-rose-500 transition-colors" data-id="element-494">
                  FAQ
                </Link>
              </li>
              <li data-id="element-495">
                <Link to="/privacy-policy" className="text-gray-600 hover:text-rose-500 transition-colors" data-id="element-496">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Information */}
          <div data-id="element-497">
            <h4 className="font-semibold text-gray-900 mb-4" data-id="element-498">Contact Us</h4>
            <ul className="space-y-3" data-id="element-499">
              <li className="flex items-start" data-id="element-500">
                <Mail className="w-5 h-5 text-rose-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-501" />
                <a href="mailto:sales@bloomandpop.co.za" className="text-gray-600 hover:text-rose-500 transition-colors text-sm" data-id="element-502">
                  sales@bloomandpop.co.za
                </a>
              </li>
              <li className="flex items-start" data-id="element-503">
                <Phone className="w-5 h-5 text-rose-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-504" />
                <a href="tel:0732736906" className="text-gray-600 hover:text-rose-500 transition-colors text-sm" data-id="element-505">
                  073 273 6906
                </a>
              </li>
              <li className="flex items-start" data-id="element-506">
                <MessageCircle className="w-5 h-5 text-green-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-507" />
                <a href="https://wa.me/27732736906" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-green-600 transition-colors text-sm" data-id="element-508">
                  WhatsApp: 073 273 6906
                </a>
              </li>
              <li className="flex items-start" data-id="element-509">
                <Globe className="w-5 h-5 text-rose-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-510" />
                <a href="https://www.bloomandpop.co.za" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-rose-500 transition-colors text-sm" data-id="element-511">
                  www.bloomandpop.co.za
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-rose-200 pt-8 text-center" data-id="element-512">
          <p className="text-gray-500 flex items-center justify-center text-sm" data-id="element-513">
            © {new Date().getFullYear()} Bloom & Pop. Made with{' '}
            <Heart className="w-4 h-4 text-rose-400 mx-1 fill-current" data-id="element-514" /> for
            celebrations everywhere.
          </p>
        </div>
      </div>
    </footer>;
}